import React from 'react';

import PlayerTitle from '../player-title/PlayerTitle';
import PlaybackControls from '../playback-controls/PlaybackControls';

import { MinimizedContainer } from './PlayerMinimized.styled';

const PlayerMinimized = () => {
  return (
    <MinimizedContainer>
      <PlayerTitle />
      <PlaybackControls />
    </MinimizedContainer>
  );
};

export default PlayerMinimized;
